<template>
  <div class="date" :class="{ 'custom-input' : customInput }">
    <div class="date-content">
      <fa :fa-class="faClass.icon"
          :solid="faClass.solid"
      />

      <div class="input-inner">
        <div v-if="label"
             :class="getLabelClass"
        >
          {{ $t(label) | lowercase }}
        </div>

        <vue-pikaday v-model="val"
                     :options="getPikadayOptions"
                     :name="name"
                     :placeholder="$t(placeholder)"
                     ref="pika"
                     :required="required"
                     autocomplete="off"
                     :class="{ 'undisplay-shadow' : !submitted }"
        />
      </div>
    </div>

    <error v-if="displayError">
      {{ errorMessage }}
    </error>
  </div>
</template>

<script>
import '@enrian/vue-pikaday/dist/vue-pikaday.min.css'
import pikadayi18n from '@/lang/pikadayi18n'
import fa from '@/components/global/icon/fontAwesome'
import error from '@/components/frontoffice/form/error'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import i18n from '@/utils/i18n'

export default {
  components: {
    fa,
    error
  },

  mixins: [formMethods],

  props: {
    customInput: {
      type: Boolean,
      default: true
    },
    label: String,
    placeholder: {
      type: String,
      default: '_select_date'
    },
    faClass: {
      default () {
        return {
          icon: 'calendar-alt',
          solid: false
        }
      }
    },
    name: String,
    fromDateRange: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Date, String]
    },
    maxDate: Date,
    required: {
      type: Boolean,
      default: true
    },
    unlimited: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    submitted: {
      type: Boolean,
      default: false
    }
  },

  created () {
    if (this.value instanceof Date) this.val = this.value
    else if (this.value !== null) this.val = new Date(this.value)
  },

  data () {
    return {
      val: null,
      // pikadayOptions: pikadayi18n[navigator.language],
      pikadayOptions: pikadayi18n[i18n.locale],
      displayError: false,
      errorMessage: ''
    }
  },

  methods: {
    setMinDate (date) {
      this.$refs.pika.pikaday.setMinDate(date)
    },

    setMaxDate (date) {
      this.$refs.pika.pikaday.setMaxDate(date)
    },

    setDate (date) {
      this.$refs.pika.pikaday.setDate(date)
    },

    goToMonth (month) {
      this.$refs.pika.pikaday.gotoMonth(month)
    }
  },

  computed: {
    getFaColClass () {
      return this.fromDateRange ? 'col-4' : 'col-2'
    },

    getColClass () {
      return this.fromDateRange ? 'col-8' : 'col-10'
    },

    getPikadayOptions () {
      // Do not check minDate if pikadayOptions is not available (bug #4038)
      if (this.pikadayOptions === undefined) return false

      if (this.unlimited) {
        this.pikadayOptions.minDate = null
      } else {
        this.pikadayOptions.minDate = new Date()
      }

      this.pikadayOptions.bound = !this.isOpen

      return this.pikadayOptions
    },

    getDate () {
      return this.$refs.pika.pikaday.getDate()
    }
  },

  watch: {
    val (newVal) {
      this.$emit('input', newVal)
    },

    value (newVal) {
      // value should be changed regardless of the fact that is it either null or not but regarding to commit 5d99b3c5a0c8497ba9ef4c193314210a56bd67df side effects appear. So value is only changed to null if this.unlimited === true (booking filters)

      if (this.unlimited) {
        this.val = newVal
      } else if (newVal) {
        this.val = newVal
      }
    },

    maxDate (newVal) {
      this.setMaxDate(newVal)
    }
  }
}
</script>

<style lang="scss">
  .pika-label:after {
    content:" \25be";
  }

  .pika-button {
    text-align: center;

    &:hover {
      background: rgba(230, 80, 17, 0.75);
    }
  }

  .pika-week, .pika-table th abbr {
    color: #1A2050;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
  }

  .is-today .pika-button {
    background: rgba(230, 80, 17, 0.75);
    color: white;
  }

  .is-selected .pika-button {
    background: rgba(230, 80, 17, 1);
    box-shadow: none;
  }

  .is-disabled .pika-button {
    background: rgba(26, 32, 80, 0.75);
  }
</style>
